import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

import { ButtonGroup, Popover, Menu, MenuItem, Button } from '@blueprintjs/core';
import { neutral, good, warning, bad, goodBehaviours, badBehaviours } from '../../constants'
import BehaviourButton from '../../BehaviourButton'
import { selectBehaviour } from '../../behaviourControlsSlice';

import ToggleAll from './ToggleAll'
import ContextOptions from './ContextOptions'
import SendBehaviour from './SendBehaviour'
import '../../BehaviourStyle.css' 


const BehaviourManagement = () => {
    const [askQuestionDropdownOpen, setAskQuestionDropdownOpen] = useState(false);
    const [askQuestionDropdownValue, setAskQuestionDropdownValue] = useState('');
    const [isAskQuestionDropdownDisabled, setIsAskQuestionDropdownDisabled] = useState(true);
    const [chattingDropdownOpen, setChattingDropdownOpen] = useState(false);
    const [chattingDropdownValue, setChattingDropdownValue] = useState('');
    const [isChattingDropdownDisabled, setIsChattingDropdownDisabled] = useState(true);
    const currentBehaviour = useSelector(selectBehaviour);

    useEffect(() => {
        setIsAskQuestionDropdownDisabled(currentBehaviour !== 'AskQuestion');
        setIsChattingDropdownDisabled(currentBehaviour !== 'Chatting+');

        if (currentBehaviour !== 'AskQuestion') {
            setAskQuestionDropdownValue('');
        }
        if (currentBehaviour !== 'Chatting+') {
            setChattingDropdownValue('');
        }
        setAskQuestionDropdownOpen(false); // Schlie�e Dropdowns bei Verhaltens�nderung
        setChattingDropdownOpen(false);
    }, [currentBehaviour]);

    const handleAskQuestionDropdownItemClick = (value) => {
        setAskQuestionDropdownValue(value);
        setAskQuestionDropdownOpen(false);
        console.log('AskQuestion Dropdown Value:', value);
        // Hier Logik f�r die Auswahl im AskQuestion-Dropdown
    };

    const handleChattingDropdownItemClick = (value) => {
        setChattingDropdownValue(value);
        setChattingDropdownOpen(false);
        console.log('Chatting Dropdown Value:', value);
        // Hier Logik f�r die Auswahl im Chatting+-Dropdown
    };

    return (
        <div>
            {/*<ButtonGroup className="buttonGroupContainer">*/}
            {/*    {neutral.map(b => <BehaviourButton key={b} behaviour={b} />)}*/}
            {/*</ButtonGroup>*/}
            <ButtonGroup className="buttonGroupContainer">
                {goodBehaviours.map(b => <BehaviourButton key={b} behaviour={b} />)}
            </ButtonGroup>
            <ButtonGroup className="buttonGroupContainer">
                {warning.map(b => <BehaviourButton key={b} behaviour={b} />)}
            </ButtonGroup>
            <ButtonGroup className="buttonGroupContainer">
                {bad.map(b => <BehaviourButton key={b} behaviour={b} />)}
            </ButtonGroup>

            <div className="additionalInputContainer">
                <span>AskQuestion:</span>
                <Popover
                    isOpen={askQuestionDropdownOpen}
                    onOpen={() => setAskQuestionDropdownOpen(true)}
                    onClose={() => setAskQuestionDropdownOpen(false)}
                    disabled={isAskQuestionDropdownDisabled}
                    content={
                        <Menu>
                            <MenuItem text="Option A" onClick={() => handleAskQuestionDropdownItemClick('Option A')} />
                            <MenuItem text="Option B" onClick={() => handleAskQuestionDropdownItemClick('Option B')} />
                            <MenuItem text="Option C" onClick={() => handleAskQuestionDropdownItemClick('Option C')} />
                        </Menu>
                    }
                    placement="bottom-start"
                >
                    <Button
                        text={askQuestionDropdownValue || "Select..."}
                        rightIcon="caret-down"
                        disabled={isAskQuestionDropdownDisabled}
                    />
                </Popover>
                <span>Chatting+:</span>
                <Popover
                    isOpen={chattingDropdownOpen}
                    onOpen={() => setChattingDropdownOpen(true)}
                    onClose={() => setChattingDropdownOpen(false)}
                    disabled={isChattingDropdownDisabled}
                    content={
                        <Menu>
                            <MenuItem text="Nachricht 1" onClick={() => handleChattingDropdownItemClick('Nachricht 1')} />
                            <MenuItem text="Nachricht 2" onClick={() => handleChattingDropdownItemClick('Nachricht 2')} />
                            <MenuItem text="Nachricht 3" onClick={() => handleChattingDropdownItemClick('Nachricht 3')} />
                        </Menu>
                    }
                    placement="bottom-start"
                >
                    <Button
                        text={chattingDropdownValue || "Select..."}
                        rightIcon="caret-down"
                        disabled={isChattingDropdownDisabled}
                    />
                </Popover>
            </div>
            <div className="bottomRow">
                <div className="actionDetailsLeft">
                    <span>Action Details</span>
                    <ToggleAll />
                </div>
                <SendBehaviour />
            </div>
            <ContextOptions />
        </div>
    )
}

export default BehaviourManagement
